import React, { useEffect, useRef, useState } from "react";
import imgtest from "./../../Utils/Images/Comp 1_00079 1.png";
import { useLocation } from "react-router-dom";


const CustomChatButton = () => {
  const location = useLocation();

  const [tawkReady, setTawkReady] = useState(false);
  const readyPollRef = useRef(null);

  const searchParams = new URLSearchParams(location.search);
  const isCheck = searchParams.get("consent");

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/66fa5521e5982d6c7bb68359/1i90tp3i2";
    script.async = true;
    // Q-05: the previous code set crossOrigin="*" which is not a valid value
    // (allowed values are "anonymous" and "use-credentials").
    script.crossOrigin = "anonymous";

    script.onload = () => {
      // Q-05: track the interval in a ref so the outer cleanup can clear it
      // even if the component unmounts before Tawk_API ever resolves.
      readyPollRef.current = setInterval(() => {
        if (window.Tawk_API && typeof window.Tawk_API.maximize === "function") {
          setTawkReady(true);
          clearInterval(readyPollRef.current);
          readyPollRef.current = null;
        }
      }, 300);
    };

    document.body.appendChild(script);

    return () => {
      if (readyPollRef.current) {
        clearInterval(readyPollRef.current);
        readyPollRef.current = null;
      }
      if (script.parentNode === document.body) {
        document.body.removeChild(script);
      }
    };
  }, []);

  // Hide the default widget
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const tawkIframes = document.querySelectorAll("iframe[src*='tawk.to']");
  //     const tawkWidget = document.querySelector(".widget-visible");

  //     if (tawkIframes.length > 0 || tawkWidget) {
  //       clearInterval(interval);

  //       tawkIframes.forEach((iframe) => {
  //         iframe.setAttribute("style", "display: none !important");
  //       });

  //       if (tawkWidget) {
  //         tawkWidget.setAttribute("style", "display: none !important");
  //       }
  //     }
  //   }, 300);

  //   return () => clearInterval(interval);
  // }, []);

  const openTawk = () => {
    if (tawkReady && window.Tawk_API) {
      window.Tawk_API.maximize();
    } else {
    }
  };

  return (
    <>
      {tawkReady && !isCheck && (
        <div
          type="button"
          onClick={openTawk}
          className="tawkloader_css"
          aria-label="Open chat"
        >
          <img src={imgtest} alt="" width="40" height="40" />
        </div>
      )}
    </>
  );
};

export default CustomChatButton;
